'use es6';

import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _GoodSubTypes$EMAIL_T;

import GoodSubTypes from '../constants/GoodSubTypes';
export default (_GoodSubTypes$EMAIL_T = {}, _defineProperty(_GoodSubTypes$EMAIL_T, GoodSubTypes.EMAIL_TEMPLATES, 'email'), _defineProperty(_GoodSubTypes$EMAIL_T, GoodSubTypes.LANDING_PAGES, 'landing_page'), _defineProperty(_GoodSubTypes$EMAIL_T, GoodSubTypes.SITE_PAGES, 'site_page'), _GoodSubTypes$EMAIL_T);